var map = {
	"./admin.svg": "43a0",
	"./audit.svg": "af9e",
	"./bank.svg": "925d",
	"./channel.svg": "b91d",
	"./compliance.svg": "9ac6",
	"./fintech.svg": "0165",
	"./fraud.svg": "193c",
	"./list.svg": "d517",
	"./market.svg": "b153",
	"./monitor.svg": "9306",
	"./retail.svg": "7d6a",
	"./secure.svg": "5297",
	"./sedan.svg": "33a3",
	"./subject.svg": "f822"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";